import React, { useState, useEffect } from "react";
import axios from "axios";
import progressGif from "../../images/progress.gif";
import Shop_Wise_NFSA_State_Dist_Sales from "./Shop_Wise_NFSA_State_Dist_Sales";

const Shop_Wise_NFSA_State_Sales_Report = ({ heading }) => {
  const [nfsaType, setNfsaType] = useState("N");

  const [month, setMonth] = useState("");
  const [months, setMonths] = useState([]);
  const [monthsLoading, setMonthsLoading] = useState(true);
  const [monthsError, setMonthsError] = useState("");
  const [year, setYear] = useState("");
  const [years, setYears] = useState([]);

  const [submittedType, setSubmittedType] = useState(null);
  const [submittedMonth, setSubmittedMonth] = useState(null);
  const [submittedYear, setSubmittedYear] = useState(null);

  const [showTable, setShowTable] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

 
  useEffect(() => {
    const fetchMonths = async () => {
      try {
        setMonthsLoading(true);
        const response = await axios.get(`${process.env.REACT_APP_URL}/api/fpsSales/months`);
        setMonths(response.data);

        const currentMonth = new Date().getMonth() + 1;
        setMonth(currentMonth.toString());
      } catch (err) {
        console.error(err);
        setMonthsError("Failed to fetch months");
      } finally {
        setMonthsLoading(false);
      }
    };

    fetchMonths();
  }, []);

 
  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const yearList = [];
    for (let y = 2019; y <= currentYear; y++) yearList.push(y);
    setYears(yearList);

    setYear(currentYear.toString());
  }, []);

  const handleSubmit = () => {
    setShowTable(false);
    setSubmitLoading(true);

    setSubmittedType(nfsaType);
    setSubmittedMonth(month);
    setSubmittedYear(year);

    setTimeout(() => {
      setSubmitLoading(false);
      setShowTable(true);
    }, 800);
  };

  const handleBack = () => {
    setShowTable(false);
    setSubmitLoading(false);
  };

  return (
    <div className="wrapper row3">
      <div id="container">
        <div style={{ display: "flex", justifyContent: "center" }}>
          <table width="50%">
            <thead>
              <tr className="tableheader">
                <th colSpan={8}>{heading}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan={8}>
                  <div style={{ display: "flex", gap: "15px", justifyContent: "center" }}>
                    <div>
                      <label>Alloted Month</label>
                      <select
                        value={month}
                        onChange={(e) => setMonth(e.target.value)}
                        style={{ padding: "5px", fontSize: "15px", marginLeft: "50px" }}
                      >
                        {months.map((m) => (
                          <option key={m.month} value={m.month}>
                            {m.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div>
                      <label>Alloted Year</label>
                      <select
                        value={year}
                        onChange={(e) => setYear(e.target.value)}
                        style={{ padding: "5px", fontSize: "15px", marginLeft: "50px" }}
                      >
                        {years.map((y) => (
                          <option key={y} value={y}>
                            {y}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div>
                      <label>Type</label>
                      <select
                        value={nfsaType}
                        onChange={(e) => setNfsaType(e.target.value)}
                        style={{ padding: "5px", fontSize: "15px", marginLeft: "50px" }}
                      >
                        <option value="N">NFSA</option>
                        <option value="S">Non-NFSA</option>
                      </select>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td colSpan={8} align="center" style={{ paddingTop: "15px" }}>
                  <button
                    onClick={handleSubmit}
                    className="button button2"
                    disabled={submitLoading}
                    style={{ marginRight: "10px" }}
                  >
                    Submit
                  </button>
                  <button onClick={handleBack} className="button button2">
                    Back
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        {submitLoading && (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <img src={progressGif} alt="Loading..." width="250" height="15" />
          </div>
        )}
        {!submitLoading && showTable && (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <Shop_Wise_NFSA_State_Dist_Sales
              nfsaType={submittedType}
              month={submittedMonth}
              year={submittedYear}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Shop_Wise_NFSA_State_Sales_Report;
